@if (gridFilterGroup.presentation !== 'switch') {
<button
    #filterButton
    [id]="'toggle-button-id-' + filterGroupName"
    class="toggle-header-button"
    type="button"
    (click)="handleHeaderToggle()"
    (keypress.enter)="handleHeaderToggle()"
    [class.keyboard-navigation]="layoutFacade.keyboardNavigation$ | async"
    [attr.aria-controls]="'toggle-content-' + filterGroupName"
    [attr.aria-expanded]="!collapsed">
    <ng-container *ngTemplateOutlet="toggleHeader"></ng-container>
</button>
} @if (shouldDisplaySwitch()) {
<h-switch-button [isSwitchEnabled]="(isSwitchChecked$ | async) === true" (checked)="switchFilterClicked($event)"
    ><ng-container *ngTemplateOutlet="toggleHeader"></ng-container
></h-switch-button>
}

<ng-template #toggleHeader>
    <span class="toggle-header-text">
        <div
            class="toggle-text label-medium-bold-uppercase"
            aria-hidden="true"
            [attr.aria-labelledby]="'toggle-title-label-' + filterGroupName">
            {{ filterGroupName }}
            @if (countSelectedFilters && !shouldDisplaySwitch()) {
            <span> &nbsp;({{ countSelectedFilters }}) </span>
            }
        </div>
        <span hSrOnlyNoSnippet [id]="'toggle-title-label-' + filterGroupName">
            {{ filterGroupName }}, {{ countSelectedFilters }}
            <ng-container i18n="@@hermes.accessibility.selected_filters"> Selected filters </ng-container>
        </span>
    </span>
    <span class="toggle-header-spacer"></span>
    @if (gridFilterGroup.presentation !== 'switch') {
    <span class="toggle-header-toggler">
        <svg:svg
            class="toggler-icon"
            viewBox="0 0 24 24"
            [@togglerIcon]="collapsed ? 'hidden' : 'visible'"
            focusable="false"
            [attr.aria-hidden]="'true'">
            <svg:path
                d="M 3,9 12,18 21,9"
                stroke="black"
                stroke-width="3"
                fill="none"
                [attr.stroke-linecap]="'round'" />
        </svg:svg>
    </span>
    }
</ng-template>

@if (gridFilterGroup.presentation !== 'switch') {
<div
    [attr.id]="'toggle-content-' + filterGroupName"
    #toggleContent
    [@toggleContent]="collapsed ? 'hidden' : 'visible'"
    (@toggleContent.start)="toggleClassAfterAnimation($event)"
    (@toggleContent.done)="toggleClassAfterAnimation($event)"
    class="toggle-content border-bottom hidden"
    [attr.role]="gridFilterGroup.presentation === 'slider' ? 'region' : 'group'"
    [attr.aria-labelledby]="'toggle-title-' + filterGroupName">
    <div class="toggle-filter-group">
        <h-grid-filter-group [gridFilterGroup]="gridFilterGroup" [isOpen]="!collapsed"></h-grid-filter-group>
    </div>
</div>
}
